import { render, staticRenderFns } from "./IsokiaKashani.vue?vue&type=template&id=3cce9eb4&scoped=true&"
import script from "./IsokiaKashani.vue?vue&type=script&lang=js&"
export * from "./IsokiaKashani.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cce9eb4",
  null
  
)

export default component.exports